import { Divider as MUIDivider } from '@mui/material';

export default function Divider() {
    return <MUIDivider />;
}
